<script lang="ts" setup>
const { t } = useI18n();

useSeoMeta({
  title: t('title'),
  description: t('description'),
  ogTitle: t('title'),
  ogDescription: t('description'),
});
</script>

<template>
  <main>
    <SectionContactsHeader />
    <LazyIdleSectionContactsList hydrate-on-idle />
    <LazyIdleSectionContactsForm hydrate-on-idle />
    <LazyIdleSectionSubscribe hydrate-on-idle />
  </main>
</template>

<i18n>
ru:
  title: 'Где купить косметику: онлайн-маркетплейсы, офлайн-магазины и контакты'
  description: 'Полный список мест, где можно купить косметику DTMS: Ozon, Золотое Яблоко, Foam. Адреса офлайн-магазинов и контактная информация для связи.'

en:
  title: 'Where to Buy Cosmetics: Online Marketplaces, Offline Stores, and Contacts'
  description: 'Full list of places where you can buy DTMS cosmetics: Ozon, Gold Apple, Foam. Addresses of offline stores and contact information.'
</i18n>

<style lang="scss">
.contactsForm {
  &__subscribe {
    @include mq('sm') {
      display: none;
    }
  }
}
</style>
